import React from 'react';

const Nav = () => {
  return (
    <header>
      <div className='w-full h-auto flex items-center justify-between md:h-[96px] text-[#232323]'>
        <div className='h-auto w-[auto] flex items-center justify-center px-[12px]'>
          <h2 className='text-[16px] tracking-[normal] font-bold  text-[#232323] leading-[24px] text-3xl sm:tracking-tight text-center'>
            Wootlab Academy
          </h2>
        </div>
        <div className='flex justify-end items-center lg:mt-0 lg:ml-4 w-[961px] h-[71px]'>
          <a
            href='https://wootlabacademy.com/#/'
            target={'_blank'}
            className=' w-[102px] h-[52px] flex items-center justify-center items-center  rounded-[50px] text-white shadow-sm  focus:ring-offset-2 bg-[#041a45] m-[10px] text-[17px] leading-[24px] tracking-[normal]'
          >
            Sign Up
          </a>
        </div>
      </div>
    </header>
  );
};

export default Nav;
